import { render, staticRenderFns } from "./ScreenBoard.vue?vue&type=template&id=97a17e38&scoped=true"
import script from "./ScreenBoard.vue?vue&type=script&lang=js"
export * from "./ScreenBoard.vue?vue&type=script&lang=js"
import style0 from "./ScreenBoard.vue?vue&type=style&index=0&id=97a17e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a17e38",
  null
  
)

export default component.exports